const pageNameKey = "versionStringInfo";

export const versionStringInfoEn = {
  [pageNameKey]: {
    linkText: "Version",
    copySuccessText: "Version string copied to clipboard",
    copyErrorText: "Failed to copy version string to clipboard",
    toolTipText: "Copy Version String",
  },
};

export const versionStringInfoPtBr = {
  [pageNameKey]: {
    linkText: "Versão",
    copySuccessText: "String da versão copiada para a área de transferência",
    copyErrorText:
      "Falha ao copiar a string da versão para a área de transferência",
    toolTipText: "Copiar string da versão",
  },
};

export const versionStringInfoDe = {
  [pageNameKey]: {
    linkText: "Version",
    copySuccessText: "Versions-String in die Zwischenablage kopiert",
    copyErrorText:
      "Fehler beim Kopieren des Versions-Strings in die Zwischenablage",
    toolTipText: "Versions-String kopieren",
  },
};

export const versionStringInfoZhHans = {
  [pageNameKey]: {
    linkText: "版本",
    copySuccessText: "版本字符串已复制到剪贴板",
    copyErrorText: "无法将版本字符串复制到剪贴板",
    toolTipText: "复制版本字符串",
  },
};

export const versionStringInfoIt = {
  [pageNameKey]: {
    linkText: "Versione",
    copySuccessText: "Versione copiata negli appunti",
    copyErrorText: "Impossibile copiare la versione negli appunti",
    toolTipText: "Copia Versione",
  },
};

export const versionStringInfoEs = {
  [pageNameKey]: {
    linkText: "Versión",
    copySuccessText: "Cadena de versión copiada al portapapeles",
    copyErrorText: "No se pudo copiar la cadena de versión al portapapeles",
    toolTipText: "Copiar cadena de versión",
  },
};

export const versionStringInfoNl = {
  [pageNameKey]: {
    copyErrorText:
      "Fout bij het kopiëren van de versiestring naar het klembord",
    copySuccessText: "Versiestring naar klembord gekopieerd",
    linkText: "Versie",
    toolTipText: "Versiestring kopiëren",
  },
};

export const versionStringInfoTr = {
  [pageNameKey]: {
    linkText: "Sürüm",
    copySuccessText: "Sürüm dizesi panoya kopyalandı",
    copyErrorText: "Sürüm dizesi panoya kopyalanamadı",
    toolTipText: "Sürüm dizesini kopyala",
  },
};
